<template>
  <div id="app" :class="browserClass">
    <div v-if="!loading && apiStatus">
      <app-topbar/>
      <router-view/>
      <app-footer/>
      <login-modal v-if="!auth"/>
      <extras-modal/>
      <addresses-modal/>
      <validation-modal/>
      <modal-texts/>
      <payment-verification-modal/>
      <image-modal/>
      <image-modal-slider/>
    </div>
    <div v-else-if="loading && apiStatus">
      <div class="page--centered-wrapper">
        <div class="page--centered">
          <loader/>
        </div>
      </div>
    </div>
    <div v-else class="page-error">
      <div class="error-logo">
        <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 187.8 55.4"
             style="enable-background:new 0 0 187.8 55.4; width: 360px"
             xml:space="preserve"
        >
        <g id="Calque_2_1_">
            <g id="Calque_1-2">
                <polygon fill="#FFF"
                         points="75.6,0.7 75.6,55 67.6,55 67.6,26.8 59.1,26.8 59.1,55 51,55 51,0.7 59.1,0.7 59.1,26.4 67.6,26.4 67.6,0.7 		"/>
              <path fill="#FFF" d="M98.6,28c0-14.6-0.6-27.7-4.7-27.7s-4.7,13-4.7,27.6c0,14.4,0.6,27.5,4.7,27.5S98.6,42.4,98.6,28 M107.3,28
                    c0,15.7-6,27.8-13.4,27.8S80.5,43.6,80.5,28c0-16,6-28,13.4-28S107.3,12,107.3,28"/>
              <path fill="#FFF" d="M136,13c-2.3-7.1-6.5-11.9-9.6-12v54h-8.2V1c-3.2,0.1-7.4,4-9.6,12V0.7H136V13z"/>
              <path fill="#FFF" d="M161.9,41v14h-21.3V0.7l20.6-0.1v12.3c-2.7-8-5.3-11.9-12.4-11.9v25.5c3.2-0.2,6-2.3,8.4-6.4V33c-2.4-4-5.2-6.1-8.4-6.3
                    v28C154.4,54.6,159.2,50.1,161.9,41"/>
              <path fill="#FFF" d="M187.8,41v14H167V0.7h8.1v54C180.6,54.4,185.1,49.9,187.8,41"/>
              <path fill="#FFF"
                    d="M29.9,55h-8.1V2.2l-8.9,43.1L0.4,1.2C0.4,35.7,1.2,44.6,7,55H0V0.7h8.3L16,28.2l-0.1,0.4l5.8-27.9h8.2V55z"/>
              <path fill="#FFF"
                    d="M36.7,22.8c3.1-0.7,5.9-2.4,8-4.8v37h-8V22.8z M35.7,8.2c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S35.7,11,35.7,8.2"/>
            </g>
        </g>
        </svg>

      </div>
      <div class="error-title">
        <h1>Error 500 <i class="la la-meh"></i></h1>
      </div>
      <div class="error-message">
        <p>Une erreur est survenue, veuillez réessayer plus tard.</p>
        <p>An error occured, please try again later</p>
      </div>
    </div>
  </div>
</template>
<style scoped>

  .page-error {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #c15842;
    text-align: center;
    padding: 4rem;
  }

  .page--centered-wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
  }

  .page--centered {
    flex: 0 0 auto;
    margin: auto;
    display: inline-block;
    width: 100px;
    height: 100px;
  }

  .crisp-client .crisp-1rjpbb7 .crisp-ws3gf1, .crisp-client .crisp-1rjpbb7 .crisp-13h0akn:before, .crisp-client .crisp-1rjpbb7 .crisp-13h0akn:after {
    background-color: var(--grey-purple) !important;
  }
</style>
<script>

  import '../static/style3/style.css';
  import '../static/style3/button.css';
  import '../static/style3/topbar.css';
  import '../static/style3/slider.css';
  import '../static/style3/home-finder.css';
  import '../static/fonts/font.css';
  import '../static/style3/slider-animations.css';
  import '../static/style3/video-player.css';
  import '../static/style3/v-calendar.css';
  import '../static/style3/home-discover.css';
  import '../static/style3/room-highlighted.css';
  import '../static/style3/home-promos.css';
  import '../static/style3/home-blog.css';
  import '../static/style3/home-texts.css';
  import '../static/style3/footer.css';
  import '../static/style3/responsivehome.css';
  import '../static/style3/modal.css';
  import '../static/style3/input.css';
  import '../static/style3/layout.css';
  import '../static/style3/tunnel.css';
  import '../static/style3/concept-menu.css';
  import '../static/style3/suite-menu.css';
  import '../static/style3/room.css';
  import '../static/style3/card.css';
  import '../static/style3/register.css';
  import '../static/style3/extras.css';
  import '../static/style3/privacy.css';
  import '../static/style3/booking-history.css';
  import '../static/style3/concept.css';
  import '../static/style3/profile.css';
  import '../static/style3/invest.css';
  import '../static/style3/customer-alliance.css';
  import '../static/style3/room-date-picker.css';
  import '../static/style3/step4.css';

  import '../static/style2/line-awesome.min.css';
  import '../static/style2/placeholder-loading.min.css';

  import appTopbar from './components/topbar';
  import appFooter from './components/footer';
  import loader from './components/loader.component';
  import {mapState} from 'vuex';
  import LoginModal from './components/login-modal';
  import ExtrasModal from './components/extras-modal';
  import AddressesModal from './pages/client/part/addresses-modal';
  import ValidationModal from './components/validation-modal';
  import ModalTexts from "./components/modal-texts";
  import PaymentVerificationModal from "./pages/client/part/payment-verification-modal";
  import {MetaHelper} from "./helpers/meta.helper";
  import {eachRouteUpdate} from "./router/guards/require-auth.guard";
  import ImageModal from "./components/image-modal";
  import ImageModalSlider from "./components/image-modal-slider";

  export default {
    name: 'App',
    metaInfo() {
      return MetaHelper.home(this.$store.state.lang.currentLang)
    },
    components: {
      ImageModalSlider,
      ImageModal,
      PaymentVerificationModal,
      ModalTexts,
      ValidationModal,
      LoginModal,
      ExtrasModal,
      appTopbar,
      appFooter,
      loader,
      AddressesModal
    },
    watch: {
      $route: eachRouteUpdate
    },
    computed: {
      browserClass () {
        const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        const isFirefox = typeof InstallTrigger !== 'undefined';
        const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
        const isIE = /*@cc_on!@*/false || !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
        return isSafari ? 'safari' : 'normal';
      },
      ...mapState({
        loading: state => state.lang.loading,
        auth: s => s.client.auth,
        apiStatus: (state, getters) => getters.isAPIOnline,
      })
    },
    mounted () {
      window.CRISP_WEBSITE_ID = 'd420f19d-f24f-4d45-aab8-a0b0b2bed4a2';
    }
  };
</script>



// WEBPACK FOOTER //
// src/App.vue